module.exports = __webpack_public_path__ + "bac84938b6dbef1935bb577f1400aed7.pdf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/data/coloring/fr1.pdf
// module id = 927
// module chunks = 3